<script>
    import { updateFilter, deleteFilter } from '@/api/filters.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_FILTER_EDIT},
        },
        methods: {
            async save() {
                const data = this.$store.getters.FILTER_DATA_EDIT;
                const response = await updateFilter(data);
                if (response === true) {
                    const filter = this.$store.getters.FILTER_BY_ID(data.asset_type_id, data.id);
                    filter.name = data.name;
                    filter.description = data.description;
                    filter.filter_type = data.filter_type;
                    await this.close();
                }
            },
            async deleteObj() {
                const data = this.$store.getters.FILTER_DATA_EDIT;
                const response = await deleteFilter(data.id);
                if (response === true) {
                    this.$store.commit('FILTER_SPLICE', {
                        assetID: data.asset_type_id, 
                        filterID: data.id,
                    })
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_FILTER_EDIT', false);
            },
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        @click="save"
        class="button_blue_100"
    >Save</button>
    <button
        @click="deleteObj"
        class="button_blue_100 button_red ml_10"
    >Delete</button>
    <button
        @click="close"
        class="button_blue_100 close_button mr_10"
    >Close</button>
</template>